export enum ColorScheme {
  LIGHT = "light",
  DARK = "dark"
}
